module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-group-detail"
  }, [_c('div', {
    staticClass: "view-title"
  }, [(_vm.workgroup && _vm.workgroup.project_name) ? _c('span', [_vm._v(_vm._s(_vm.workgroup.project_name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "csos-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.activeTabName
    },
    on: {
      "tab-click": _vm.onClickTab
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "clearfix panel-search"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.select
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.searchForm.type = $$v
      },
      expression: "searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1)], 1), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "icon": "search",
      "disabled": !_vm.searchForm.type,
      "on-icon-click": _vm.onSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch($event)
      }
    },
    model: {
      value: (_vm.searchForm.key),
      callback: function($$v) {
        _vm.searchForm.key = $$v
      },
      expression: "searchForm.key"
    }
  })], 1), _vm._v(" "), (_vm.activeTabName == 'ecs') ? _c('a', {
    attrs: {
      "href": _vm.downloadUrl
    },
    on: {
      "click": _vm.exportAnsible
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Export Ansible")])], 1) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.instance,
      "name": "ecs"
    }
  }, [_c('div', [(_vm.instances !== '') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instances
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": " ",
      "width": "30"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.type === 'LinuxServer' ? 'Linux' : 'Windows',
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": ("../../../static/images/" + (scope.row.type === 'LinuxServer' ? 'linux' : 'win32') + ".png"),
            "alt": ""
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agent_status === 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.available,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point available"
        })]) : _vm._e(), _vm._v(" "), (scope.row.agent_status !== 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unavailable,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point unavailable"
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.network_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.avaliableCode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.hideStr(scope.row.code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.onlineSession
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.online_connections < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnections(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.online_connections) + "\n\t\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.connectLog
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.logs < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnectionLogs(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.logs) + "\n\t\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "360",
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnect(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Connect")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.linuxConfig(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Config")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.manageCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Manage Code")])], 1)]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instancesList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.instancesList.totalPage,
      "page-size": 10,
      "current-page": _vm.instancesList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.instancesList.currentPage = $event
      },
      "current-change": _vm.changeProjectPage
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.database,
      "name": "rds"
    }
  }, [(_vm.databases !== '') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.databases
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": " ",
      "width": "35"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'PostgreSQLDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : (scope.row.type == 'OracleDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Oracle",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/oracle.png",
            "width": "16",
            "height": "12",
            "alt": ""
          }
        })]) : (scope.row.type == 'MySQLDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/mysql.png",
            "alt": "",
            "width": "16",
            "height": "16"
          }
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/mssql.png",
            "width": "16",
            "height": "14",
            "alt": ""
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.dabaseName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.db_name), function(dbName, dbIndex) {
          return _c('div', {
            key: dbIndex,
            staticClass: "database-name-item"
          }, [_vm._v(_vm._s(dbName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agent_status === 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.available,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point available"
        })]) : _vm._e(), _vm._v(" "), (scope.row.agent_status !== 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unavailable,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point unavailable"
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.network_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.avaliableCode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.hideStr(scope.row.code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.connectLog
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.logs < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnectionLogs(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.logs) + "\n\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnect(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Connect")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.manageCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Manage Code")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.check(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Check")])], 1), _vm._v(" "), (scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.startApply(scope.row, 'rds')
            }
          }
        }, [_c('translate', [_vm._v("Start Application")])], 1) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.databasesList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.databasesList.totalPage,
      "page-size": 10,
      "current-page": _vm.databasesList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.databasesList.currentPage = $event
      },
      "current-change": _vm.changeProjectPage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    ref: "rightPanel",
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "reloadTunnelCode": _vm.reloadTunnelCode,
      "reloadOnlineConnects": _vm.reloadOnlineConnects,
      "reloadPojectResource": _vm.reloadPojectResource,
      "onShowModal": _vm.onShowModal,
      "startApplyEvent": _vm.startApplyEvent,
      "onViewLog": _vm.handleViewLog
    }
  })], 1), _vm._v(" "), (_vm.m) ? _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.createCode,
      "visible": _vm.showModal.showCreateModal,
      "custom-class": "create-code-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showCreateModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.m && _vm.m.safe.network_safe_mode && _vm.m.resource.resource_type === 'ecs' && _vm.m.extension.os === 'linux') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.securityMode
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && _vm.m.safeMode),
      expression: "!m.safe.safe_mode_approver && m.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && !_vm.m.safeMode),
      expression: "!m.safe.safe_mode_approver && !m.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(" : Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 0),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && !_vm.m.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && !m.safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver || (_vm.m.safe.safe_mode_approver && _vm.m.safe.safe_mode_application == 1)),
      expression: "!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchSafeMode($event)
      }
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.validTime
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    on: {
      "change": _vm.changeExpireTime
    },
    model: {
      value: (_vm.m.expire),
      callback: function($$v) {
        _vm.m.expire = $$v
      },
      expression: "m.expire"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "day",
      "label": _vm.attrText.oneDay
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "month",
      "label": _vm.attrText.oneMonth
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "custom",
      "label": _vm.attrText.customize
    }
  })], 1), _vm._v(" "), (_vm.m.expire === 'custom') ? _c('el-date-picker', {
    staticClass: "code-input",
    attrs: {
      "type": "datetime",
      "picker-options": _vm.safeOptions,
      "placeholder": _vm.attrText.selectDate
    },
    model: {
      value: (_vm.m.validTime),
      callback: function($$v) {
        _vm.m.validTime = $$v
      },
      expression: "m.validTime"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.m) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": _vm.attrText.tipallowIp
    },
    on: {
      "change": _vm.ipInput
    },
    model: {
      value: (_vm.m.client_ip),
      callback: function($$v) {
        _vm.m.client_ip = $$v
      },
      expression: "m.client_ip"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "div"
    }
  }, [_vm._v("IPs are separated by semicolons \";\", and there is no limit if left blank")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal.showCreateModal = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.m.saving,
      "disabled": _vm.m.validTime < new Date().getTime()
    },
    on: {
      "click": _vm.createCode
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.modifyCode,
      "visible": _vm.showModal.modifyCreateModal,
      "custom-class": "modify-code-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.modifyCreateModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.codeObj && _vm.codeObj.safe.network_safe_mode && _vm.codeObj && _vm.codeObj.resource.resource_type === 'ecs' && _vm.codeObj.os === 'linux') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.securityMode,
      "prop": "safeMode"
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode),
      expression: "!codeObj.safe.safe_mode_approver && codeObj.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver && !_vm.codeObj.safeMode),
      expression: "!codeObj.safe.safe_mode_approver && !codeObj.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && (_vm.codeObj.safe.safe_mode_application == 3 || _vm.codeObj.safe.safe_mode_application == 4)),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(" : Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 0),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 1),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 2),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && !_vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 1),
      expression: "codeObj.safe.safe_mode_approver && !codeObj.safeMode && codeObj.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v(": green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && (_vm.codeObj.safe.safe_mode_application == 3 || _vm.codeObj.safe.safe_mode_application == 4)),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver || (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safe.safe_mode_application == 1)),
      expression: "!codeObj.safe.safe_mode_approver || (codeObj.safe.safe_mode_approver && codeObj.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchModifySafeMode($event)
      }
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 2),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.validTime,
      "prop": "validTime"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    on: {
      "change": _vm.modifyCodeSelectChange
    },
    model: {
      value: (_vm.modifyTime.type),
      callback: function($$v) {
        _vm.modifyTime.type = $$v
      },
      expression: "modifyTime.type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "day",
      "label": _vm.attrText.oneDay
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "month",
      "label": _vm.attrText.oneMonth
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "custom",
      "label": _vm.attrText.customize
    }
  })], 1), _vm._v(" "), (_vm.modifyTime.type === 'custom') ? _c('el-date-picker', {
    staticClass: "code-input",
    attrs: {
      "type": "datetime",
      "picker-options": _vm.safeOptions,
      "placeholder": _vm.attrText.selectDate
    },
    on: {
      "change": function($event) {
        _vm.modifyTime.isSelectTime = false
      }
    },
    model: {
      value: (_vm.modifyTime.time),
      callback: function($$v) {
        _vm.modifyTime.time = $$v
      },
      expression: "modifyTime.time"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifyTime.isSelectTime) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.attrText.selectDate))]) : _vm._e()], 1), _vm._v(" "), (_vm.codeObj) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": _vm.attrText.tipallowIp
    },
    model: {
      value: (_vm.codeObj.allow_ip),
      callback: function($$v) {
        _vm.codeObj.allow_ip = $$v
      },
      expression: "codeObj.allow_ip"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "div"
    }
  }, [_vm._v("IPs are separated by semicolons \";\", and there is no limit if left blank")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal.modifyCreateModal = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), (_vm.tempObj) ? _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.temporaryAuthorize,
      "visible": _vm.showModal.showTempModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showTempModal = $event
      },
      "close": function($event) {
        _vm.closeTempModal()
      }
    }
  }, [_c('el-form', {
    ref: "tempObjForm",
    attrs: {
      "label-width": "200px",
      "model": _vm.tempObj,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "m-b-none",
    attrs: {
      "label": _vm.attrText.validTime,
      "prop": "expire_time"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    model: {
      value: (_vm.tempObj.expire_time),
      callback: function($$v) {
        _vm.tempObj.expire_time = $$v
      },
      expression: "tempObj.expire_time"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "30",
      "label": ("30 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "60",
      "label": ("60 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "120",
      "label": ("120 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "customize",
      "label": _vm.attrText.customize
    }
  })], 1)], 1), _vm._v(" "), (_vm.tempObj.expire_time == 'customize') ? _c('el-form-item', {
    staticClass: "p-l-200",
    attrs: {
      "prop": "expire_time_customize"
    }
  }, [_c('el-input', {
    staticClass: "code-input-time",
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.tempObj.expire_time_customize),
      callback: function($$v) {
        _vm.tempObj.expire_time_customize = _vm._n($$v)
      },
      expression: "tempObj.expire_time_customize"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("minutes")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "p-l-200"
  }, [_c('translate', [_vm._v("This expiration time is not limited by the SSH or RDP timeout set on the host.")])], 1), _vm._v(" "), (!_vm.tempObj.showNewTemp && _vm.tempObj.autologin) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName,
      "prop": "username"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    model: {
      value: (_vm.tempObj.username),
      callback: function($$v) {
        _vm.tempObj.username = $$v
      },
      expression: "tempObj.username"
    }
  }, [_c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tempObj.usernameList.length > 1),
      expression: "tempObj.usernameList.length > 1"
    }],
    attrs: {
      "value": "",
      "label": _vm.attrText.select
    }
  }), _vm._v(" "), _vm._l((_vm.tempObj.usernameList), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "value": user
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.tempObj.showNewTemp || (!_vm.tempObj.showNewTemp && !_vm.tempObj.autologin)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.serverUser,
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "auto-complete": "new-password"
    },
    on: {
      "input": _vm.onTempCredentialChange
    },
    model: {
      value: (_vm.tempObj.username),
      callback: function($$v) {
        _vm.tempObj.username = $$v
      },
      expression: "tempObj.username"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tempObj.showNewTemp || (!_vm.tempObj.showNewTemp && !_vm.tempObj.autologin)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.serverPsw,
      "prop": "psw"
    }
  }, [_c('div', {
    staticClass: "psw-test-wrap"
  }, [_c('el-input', {
    staticClass: "code-input-psw",
    attrs: {
      "auto-complete": "new-password",
      "type": "password"
    },
    on: {
      "input": _vm.onTempCredentialChange
    },
    model: {
      value: (_vm.tempObj.psw),
      callback: function($$v) {
        _vm.tempObj.psw = $$v
      },
      expression: "tempObj.psw"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "test-btn",
    attrs: {
      "loading": _vm.tempTesting
    },
    on: {
      "click": _vm.testPasswordConnection
    }
  }, [(_vm.tempTesting) ? _c('span') : _c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (_vm.tempTestPassed) ? _c('span', {
    staticClass: "test-status test-status-success"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v(" "), _c('translate', [_vm._v("Test passed")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP,
      "prop": "allow_ip"
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "pattern": _vm.allowIPPattern,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tempObj.allow_ip),
      callback: function($$v) {
        _vm.tempObj.allow_ip = $$v
      },
      expression: "tempObj.allow_ip"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(" IPs are separated by semicolons \";\", and there is no limit if left blank ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeTempModal()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.tempObj.saving,
      "disabled": _vm.tempNeedTest && !_vm.tempTestPassed
    },
    on: {
      "click": _vm.tempAuth
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.temporaryAuthorize,
      "visible": _vm.showModal.showTempModalSuccess
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showTempModalSuccess = $event
      },
      "close": _vm.closeTempModalSuccess
    }
  }, [(_vm.tempWinObj) ? _c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.tempWinObj.type === 'linux') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectAddress
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tempWinObj.linkUrl))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.linkUrl),
      expression: "tempWinObj.linkUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)]), _vm._v(" "), (_vm.tempWinObj.tmpPsw) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.temporarypsw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tempWinObj.tmpPsw))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpPsw),
      expression: "tempWinObj.tmpPsw",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-l-note"
  }, [_c('translate', [_vm._v("Note: The link is only available once (Valid time:")]), _vm._v(_vm._s(_vm.tempObj.expire_time === 'customize' ? Math.round(_vm.tempObj.expire_time_customize) : _vm.tempObj.expire_time) + " "), _c('translate', [_vm._v("minutes)")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempWinObj.type === 'win32') ? _c('div', {
    staticClass: "temp-win"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Host")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.host))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.host),
      expression: "tempWinObj.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Temporary user")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.tmpUsername))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpUsername),
      expression: "tempWinObj.tmpUsername",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Temporary password")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.tmpPsw))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpPsw),
      expression: "tempWinObj.tmpPsw",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('translate', [_vm._v("Note: The user and password are only available once (Valid time:")]), _vm._v(_vm._s(_vm.tempObj.expire_time === 'customize' ? Math.round(_vm.tempObj.expire_time_customize) : _vm.tempObj.expire_time) + " "), _c('translate', [_vm._v("minutes)")])], 1)], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.previewSQL,
      "visible": _vm.showModal.previewSQL
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.previewSQL = $event
      }
    }
  }, [(_vm.showModal.previewSQL) ? _c('CodemirrorEditor', {
    ref: "codemirrorEditor",
    attrs: {
      "value": _vm.verifyData.sql
    },
    on: {
      "input": _vm.onEditorInput
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal.previewSQL = false
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志内容查看",
      "visible": _vm.viewLogShow,
      "width": "90%",
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewLogShow = $event
      },
      "close": _vm.closeViewLogDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.viewLogLoading),
      expression: "viewLogLoading"
    }],
    staticClass: "log-view-content",
    attrs: {
      "element-loading-text": "加载日志内容中..."
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.logContent))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.viewLogShow = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c875c89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/workgroup-detail.vue
// module id = 573
// module chunks = 4 5 6